<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.superAmbassador.list")}}</span>
    <div class="list-container">
      <AveineSuperAmbassadorList :APIbaseURL="APIbaseURL" />
    </div>
  </div>
</template>

<script>

import { AveineSuperAmbassadorList } from 'aveine-super-ambassador'
export default {
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Index',
  components: {
    AveineSuperAmbassadorList
  }
}
</script>
